import React from 'react';
import {Breadcrumbs, Typography} from "@mui/material";
import {PWMLink} from "../PWMLink";

const PWMBreadcrumbs: React.FC<IPWMBreadcrumbsProps> = (props) => {

  return (
    <Breadcrumbs
      separator="/"
      sx={{mt: 1, mb: 1, ml: 2}}
    >
      {props.data.map(getComponent)}
    </Breadcrumbs>
  )
};

export default PWMBreadcrumbs;

interface IPWMBreadcrumbsProps {
  children?: React.ReactNode;
  data: BreadcrumbData[];
}

export interface BreadcrumbData {
  href?: string;
  name: string;
}

const getComponent = ({href, name}: BreadcrumbData, i: number) => {
  const key = `${href}-${i}`;
  if (href) {
    return <PWMLink key={key} href={href}>{name}</PWMLink>;
  } else {
    return <Typography key={key} color="textSecondary" variant="subtitle2">{name}</Typography>
  }
}